import { useEffect, useState } from 'react';

/**
 * Right edge (px) of the app sidebar marked with `data-app-sidebar`, kept in
 * sync on resize / collapse. Side drawers use it as their `left` so they span
 * from the screen's right edge up to the sidebar. 0 when there is no visible
 * sidebar (e.g. mobile).
 */
export function useSidebarEdge(): number {
  const [left, setLeft] = useState(0);
  useEffect(() => {
    const el = document.querySelector('[data-app-sidebar]') as HTMLElement | null;
    const measure = () => setLeft(el ? Math.max(0, el.getBoundingClientRect().right) : 0);
    measure();
    const ro = el && 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
    if (el && ro) ro.observe(el);
    window.addEventListener('resize', measure);
    return () => { ro?.disconnect(); window.removeEventListener('resize', measure); };
  }, []);
  return left;
}
